import { render, staticRenderFns } from "./ReminderContent.vue?vue&type=template&id=e65bed22&"
import script from "./ReminderContent.vue?vue&type=script&lang=js&"
export * from "./ReminderContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports